import LoadingIcon from '../../common/helpers/loadingicon.js';

const divNewsletter = document.getElementById("divNewsletter");
let options = null;
let observer = null;

function init () {
    divNewsletter.innerHTML = LoadingIcon;

    observer = new IntersectionObserver(callBack, options);
    if (divNewsletter) setUpObserve(divNewsletter);
}

function setUpObserve(container){
    options = { root: container, threshold: 0.9 }; // 0.9 instead of 1 for safari fix
    observer.observe(container);
}

// Callback function for the Intersection Observer
function callBack(entries, observer) {
    entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
            if (entry.target.id === "divNewsletter") {
                loadNewsletter(entry.target);
            }
        }
    });
}

async function loadNewsletter(target){
    const {default: Newsletter } = await import('./modules/newsletter.js');
    Newsletter.init();
    observer.unobserve(target);
}

init();